import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

const ColoredTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#272C3A',
        color: '#F5EFF7',
        fontSize: '13px',
        padding: '10px',
        maxWidth: '300px',
        fontWeight: 400,
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: '#272C3A',
    },
}));

function CopilotTooltip(props: {
    title: string;
    disableHoverListener?: boolean;
    placement?:
        | 'bottom-end'
        | 'bottom-start'
        | 'bottom'
        | 'left-end'
        | 'left-start'
        | 'left'
        | 'right-end'
        | 'right-start'
        | 'right'
        | 'top-end'
        | 'top-start'
        | 'top';
    children: any;
}) {
    return (
        <ColoredTooltip arrow title={props.title} placement={props.placement || 'bottom'} disableHoverListener={props.disableHoverListener}>
            {props.children}
        </ColoredTooltip>
    );
}

export default CopilotTooltip;
